module.exports = __webpack_public_path__ + "static/media/logo.9c747bbd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo.svg
// module id = 689
// module chunks = 41